<script lang="ts">
    import Artwork from '@amp/web-app-components/src/components/Artwork/Artwork.svelte';
    import { ContentKind } from '~/jet/models';
    import type { Artwork as ArtworkType } from '~/jet/models';

    // Had to change these .svg files to .svelte to have it work inside slots
    import ArtistFallback from './fallbacks/person-fill-square.svelte';
    import DefaultFallback from './fallbacks/classical-symbol-square.svelte';
    import LibraryPlaylistFolder from '~assets/icons/library_playlist_folder_outline.svg';
    import WorkFallback from './fallbacks/classical-works-square.svelte';

    export let artwork: ArtworkType | null = null;
    export let profile: string;
    export let alt: string = '';
    export let fallbackKind: ContentKind | null = null;
    export let topRoundedSecondary: boolean = false;
    export let useContainerStyle: boolean = false;
    export let forceFullWidth: boolean = true;
    export let isDecorative: boolean = true;
    export let disableAutoCenter: boolean = false;

    /**
     * forces images with baked in cropcodes to use profile crop.
     */
    export let forceCropCode: boolean = false;

    $: imageSettings = {
        forceCropCode,
    };

    $: FallbackArtwork = ((kind) => {
        switch (kind) {
            case ContentKind.Artist:
                return ArtistFallback;

            case ContentKind.PlaylistFolder:
                return LibraryPlaylistFolder;

            case ContentKind.Work:
                return WorkFallback;

            case ContentKind.Album:
            case ContentKind.Playlist:
            case ContentKind.Song:
            case ContentKind.Work:
            case null:
                return DefaultFallback;
        }
    })(fallbackKind);
</script>

<Artwork
    {artwork}
    {profile}
    {topRoundedSecondary}
    {useContainerStyle}
    {forceFullWidth}
    {imageSettings}
    {alt}
    {isDecorative}
    {disableAutoCenter}
>
    <svelte:fragment slot="placeholder-component">
        {#if FallbackArtwork}
            <div class="artwork-fallback" data-testid="artwork-fallback">
                <svelte:component this={FallbackArtwork} />
            </div>
        {/if}
    </svelte:fragment>
</Artwork>

<style lang="scss">
    .artwork-fallback,
    .artwork-fallback :global(svg) {
        width: inherit;
        height: inherit;
    }

    .artwork-fallback {
        max-width: 100%;
        max-height: 100%;
        background-color: var(--genericJoeColor);
    }
</style>
